import { forwardRef, PropsWithChildren } from 'react'
import { Box } from '../Box'
import { AsComponentProp, NativeProps } from '../types'
import { Sprinkles } from '../../theme/sprinkles.css'

type Props = PropsWithChildren<NativeProps & AsComponentProp & Sprinkles>

export const FlexBox = forwardRef<HTMLElement, Props>(({ children, ...rest }, ref) => {
	return (
		<Box ref={ref} display="flex" {...rest}>
			{children}
		</Box>
	)
})
